export default __webpack_public_path__ + "static/logo-7ac4b2fde8e1efb12401b86b7b9e4235.svg";